module.exports = __webpack_public_path__ + "img/full7-min.8c6de6c2.png";